/**
 * Prüft einen `redirect`-Parameter, bevor die Oberfläche dorthin navigiert.
 *
 * Erlaubt sind nur Pfade **innerhalb der App**: Sie beginnen mit `/`, aber nicht mit `//`
 * (protokollrelative URL auf eine fremde Domain) und nicht mit `/\` (manche Browser lesen den
 * Backslash als Schrägstrich). Alles andere ist `null` — ein Link in einer Mail darf niemanden
 * nach dem Login auf eine fremde Seite schicken (Open Redirect).
 */
export function safeRedirect(value: string | null): string | null {
  if (value === null || !value.startsWith('/')) return null;
  if (value.startsWith('//') || value.startsWith('/\\')) return null;
  return value;
}

/**
 * Die Query-Parameter für den nächsten Schritt des Anmeldewegs (Registrieren, E-Mail bestätigen,
 * Anmelden) — nur, was gesetzt ist. `company` ist die Vorbelegung des Firmennamens.
 */
export function authQuery(values: { email?: string; company?: string; redirect?: string | null }): string {
  const params = new URLSearchParams();
  if (values.email) params.set('email', values.email);
  if (values.company) params.set('company', values.company);
  if (values.redirect) params.set('redirect', values.redirect);
  return params.toString();
}
